<ng-template #overlay>
  <div class="pulse" (click)="openModal()">
    <img src="https://ryugaku.yume-kana.com/wp-content/uploads/2025/02/icon_cp_20250201_3.png" alt="キャンペーンを開く" />
  </div>
</ng-template>
